import React from "react"

const TabItem = ({
  name = "",
  title = "",
  onItemClicked = () => console.error("You passed no action to the component"),
  isActive = false,
}) => {
  return (
    <div
      className={`tab-section__tabs__${name} ${isActive ? "active" : ""}`}
      onClick={onItemClicked}
    >
      {title}
    </div>
  )
}

export default TabItem
